import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import cx from '../../../styles';
import crypto from 'crypto';
import NotificationSystem from 'react-notification-system';
import ReCAPTCHA from "react-google-recaptcha";
// import { emailCheck } from '../../../actions';
import ForgotPassword from '../forgotPassword';
import { translate } from 'react-i18next';
import {Icon} from '../../Common/Icon';
import {gtmSend} from '../../../helpers';
import CONFIG, { template } from '../../../config'
class EmailLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayName: false,
            isLoading: true,
            emailChecked: false,
            email: '',
            password: '',
            name: '',
            isCaptchaValidate: false,
            isActive: true,
            isResetActive: false,
            isShowNotification: true
        };
    }

    validateEmail = (email) => {
        const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }

    onEmailChange = (email) => {
        this.setState({ email, isLoading: true });
        if (this.validateEmail(email)) {
            this.setState({ emailChecked: true });
            this.props.emailCheck(email, (emailCount) => {
                this.setState({ isLoading: false, displayName: !emailCount });
                if(this.props.isNewUser && emailCount){return this.addNotification(this.props.t('already_registered'), 'error');}
            });
        } else {
            this.setState({ isLoading: false, displayName: false, emailChecked: false });
        }
    }

    onNameChange = (name) => {
        this.setState({ name });
    }

    onPasswordChange = (password) => {
        this.setState({ password });
    }
    onResetClick = (value) => {
        this.setState({isResetActive: value});
    }

    onEmailSignupSubmit = (e) => {
        e.preventDefault();
        if (this.state.displayName && !this.state.name) return this.addNotification(this.props.t('feedback_name_placeholder'), 'error');
        if (this.state.password.length < 6) return this.addNotification(this.props.t('password_min_6_chars'), 'error');
        const key = new Buffer('tickled012345678', 'utf8');
        const plaintext = new Buffer(this.state.password, 'utf8');
        const cipher = crypto.createCipheriv("aes-128-ecb", key, Buffer.alloc(0));
        cipher.setAutoPadding(true);
        const ciphertext = Buffer.concat([
            cipher.update(plaintext, 'utf8'),
            cipher.final()
        ]);
        const password = ciphertext.toString('base64');
        this.props.onEmailLogin({
            email: this.state.email,
            name: this.state.name,
            password: password
        }, this.addNotification);
    }

    addNotification = (message, level) => {
        if(this.state.isShowNotification){
            this.setState({isShowNotification: false})
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(()=>{
                this.setState({isShowNotification: true})
            },3000)
        }
    }

    onCaptchaChange = (value) => {
        gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', "I'm not a Bot", '--', 0, {action: "I'am not a Bot"})
        if (value) {
            this.setState({
                isCaptchaValidate: true,
            });
        } else {
            this.setState({
                isCaptchaValidate: false,
            });
        }
    }

    handleCloseClick = () => {
        this.setState({isActive : false});
         this.props.onCloseEmail();
    }

    render() {
        const t=this.props.t;

        return (
            <div className={cx("email-login", this.state.isActive ? '': 'hide', this.props.isLoginPage ? 'login-page':'', template)}>
                <span className={cx("close-modal")} onClick={()=>{this.handleCloseClick(); gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', 'Close', '--', 0, {action: 'Close'})}}>
                    <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                    <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
                </span>
                <div className={cx('ls-top')}>
                    <h2>{t('login_main_title')}</h2>
                    <p>{t('login_quality_answers')}</p>
                </div>
                <form onSubmit={this.onEmailSignupSubmit}>
                    <div>
                        <input id="input-user-email" name="input_user_email" type="email" value={this.state.email} onChange={e => this.onEmailChange(e.target.value)} placeholder={t('email')} autoComplete="off" onClick={()=>gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', 'Email', '--', 0, {action: 'Email'})} required />
                    </div>

                    <div>
                        <input id="input-user-password" name="input_user_password" type="password" value={this.state.password} onChange={e => this.onPasswordChange(e.target.value)} placeholder={t('password')} onClick={()=>gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', "Password", '--', 0, {action: 'Password'})} required minLength='6' />
                    </div>

                    {
                        (this.state.displayName && this.state.emailChecked) || this.props.isNewUser
                        ?
                            <div>
                                <input id="input-user-name" name="input_user_name" type="text" value={this.state.name} onChange={e => this.onNameChange(e.target.value)} placeholder={t('feedback_name')} onClick={()=>{gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', 'Name', '--', 0, {action: 'Name'})}} />
                            </div>
                        :
                            ""
                    }

                    {
                        !this.props.isNewUser &&
                        <div className={cx("forgot-password-text")} onClick={() => this.onResetClick(true)}>{t('forgot_password')}</div>
                    }

                    <div className={`captcha-warp`}>
                        <ReCAPTCHA
                            sitekey={CONFIG.captchaKey}
                            onChange={this.onCaptchaChange}
                        />
                    </div>
                    
                    <div onClick={()=>gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', this.props.isNewUser? 'Sign Up Click':'Login', '--', 0, {action: this.props.isNewUser? 'Sign Up Click':'Login'})}>
                        <button 
                            className={cx("btn", "btn-primary")} 
                            type="submit" 
                            id="submit"
                            disabled={this.state.isLoading || !this.state.emailChecked || !this.state.isCaptchaValidate}>
                                {this.props.isNewUser ? t('sign_up') : t('sidebar_login')}
                        </button>
                    </div>
                </form>
                
                <p>{t('login_we_dont_post')}</p>

                <p><a href='/privacy' target="_blank" onClick={()=>gtmSend(this.props.isNewUser? 'signup_process':'login_process',this.props.isNewUser? 'Sign Up':'Login', "Terms & Conditions", '--', 0, {action: 'Terms & Conditions'})}>{t('terms_and_conditions')}</a></p>
                { 
                    this.state.isResetActive &&
                        <ForgotPassword
                            isResetActive={this.state.isResetActive}
                            emailCheck={this.props.emailCheck}
                            onForgotPassword={this.props.onForgotPassword}
                            onResetClick={this.onResetClick}
                        />
                }
                <NotificationSystem ref={n => this._notificationSystem = n} />
            </div>
        );
    }

}

export default translate()(EmailLogin);